// src/pages/OrderViewer/components/PhoneStep.tsx
import React from "react";
import CardSection from "../../../components/ui/CardSection";
import Field from "../../../components/ui/Field";
import Button from "../../../components/ui/Button";
import { ErrorBanner } from "../styles";

interface PhoneStepProps {
  phone: string;
  setPhone: (value: string) => void;
  loading: boolean;
  error: string | null;
  onSubmit: () => void;
}

const PhoneStep: React.FC<PhoneStepProps> = ({
  phone,
  setPhone,
  loading,
  error,
  onSubmit,
}) => {
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit();
  };

  return (
    <CardSection
      icon="phone"
      title="Consultar pedidos pelo telefone"
      sub="Informe o número de telefone utilizado no pedido (somente números)."
    >
      <form onSubmit={handleSubmit}>
        <Field
          label="Telefone"
          value={phone}
          onChange={(value) => setPhone(value.replace(/\D/g, ""))}
          placeholder="18999999999"
          maxLength={11}
        />

        {error && <ErrorBanner>{error}</ErrorBanner>}

        <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 14 }}>
          <Button type="submit" disabled={loading || phone.length < 10}>
            {loading ? "Buscando..." : "Buscar pedidos"}
          </Button>
        </div>
      </form>
    </CardSection>
  );
};

export default PhoneStep;
